import { message } from 'antd';
import axios from 'axios';

// export const ADMIN_BASE_URL = "http://192.168.1.17:8080/api/admin"
// export const STAFF_BASE_URL = "http://192.168.1.12:8080/api/staff"
// export const PARENT_BASE_URL = "http://192.168.1.17:8080/api/parent"

export const ADMIN_BASE_URL = import.meta.env.VITE_ADMIN_BASE_URL
export const STAFF_BASE_URL = import.meta.env.VITE_STAFF_BASE_URL
export const PARENT_BASE_URL = import.meta.env.VITE_PARENT_BASE_URL

const userType = localStorage.getItem("userType") || "";
const childId = localStorage.getItem("selectedChildId") || "";
const axiosInstance = axios.create({
    
    timeout: 20000,
    headers: {
        'childid': userType === "Parents" ? childId : "",
    }
});


axiosInstance.postWithBody = (url, body, config = {}) => {
    const isFormData = body instanceof FormData;
    return axiosInstance.post(url, body, {
        ...config,
        headers: {
            ...(config.headers || {}),
            'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
            'ngrok-skip-browser-warning': true,
        },
    });
};

axiosInstance.deleteWithBody = (url, body, config = {}) => {
    return axiosInstance.request({
        method: 'DELETE',
        url,
        ...config,
        data: body,
    });
};

axiosInstance.getWithParams = (url, params) => {
    console.log("url, params", url)
    return axiosInstance.get(url, { params });
};

axiosInstance.postWithBody = (url, body, config = {}) => {
    return axiosInstance.post(url, body, config);
};


axiosInstance.interceptors.request.use(
    (config) => {
        const token =
            localStorage.getItem("token") ||
            sessionStorage.getItem("token");

        const userType =
            localStorage.getItem("userType") || "";

        const childId =
            localStorage.getItem("selectedChildId") || "";

        if (userType === "Staffs") {
            config.baseURL = STAFF_BASE_URL;
        } else if (userType === "Admin") {
            config.baseURL = ADMIN_BASE_URL;
        } else {
            config.baseURL = PARENT_BASE_URL;
        }

        if (token) {
            config.headers.Authorization = token;
        }

        // dynamic child id
        if (userType === "Parents" && childId) {
            config.headers.childid = childId;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export const setAxiosInterceptors = () => {
    axiosInstance.interceptors.response.use(
        (response) => {
            const { config, status, data } = response;
            if (["post", "put", "delete", "patch"].includes(config.method)) {
                if (status === 201 || status === 200) {
                    if (config.data instanceof FormData) {
                        config.data = new FormData()
                    }
                    message.success(data?.message || "Action successful");
                    console.warn("create successfull")
                }
            }
            return response;
        },
        (error) => {
            if (error.response
            ) {
                const { status, data } = error.response;

                if (status === 401) {
                    message.error("Unauthorized. Please log in again.");
                    // window.location.href = "/login";
                } else if (status === 400 || status === 403) {
                    message.error(data?.message || data?.data.message || "Request not allowed.");
                } else if (status >= 500) {
                    message.error("Server error. Try again later.");
                } else {
                    message.error(data?.message || "Something went wrong.");
                }
            } else {
                message.error("Network error. Please check your connection.");
            }
            return Promise.reject(error);
        }
    );
};

export default axiosInstance;
